<template>
  <div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import siteMixin from '@/utils/site-mixin';
import 'element-ui/lib/theme-chalk/message.css';
export default {
  mixins: [siteMixin],
  componentName: 'apphome',
  components: { },
  props: {
    token: String,
    hasLogin: String
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['backRoute']),
  },
  watch: {
    token() {
      this.login4Token();
    },
    hasLogin(val) {
      this.checkLogin();
    }
  },
  mounted () {
  },
  activated() {
    this.login4Token();
    let backRoute = this.backRoute;
    // 登录后的跳转链接，跳转并清除跳转链接
    if (backRoute) {
      // console.log(backRoute)
      this.$store.commit(types.JY_BACKURL_CLEAR);
      this.$router.push(backRoute);
    }
  },
  methods: {
    login4Token() {
      // console.log(this.tokens)
      if (this.token) {
        this.$store.dispatch(types.JY_LOGIN_MEMBER, {
          newtoken: this.token,
          callback: (flag) => {
            // console.log(flag, this.backRoute)
            if (flag) {
              let backRoute = this.backRoute;
              if (backRoute) {
                this.$store.commit(types.JY_BACKURL_CLEAR);
                this.$router.push(backRoute);
              } else {
                //this.$router.push('/');
                // console.log('...')
              }
            }
          }
        });
      } else {
        // console.log('check...')
        this.checkLogin();
      }
    },
  }
}
</script>
<style lang="less" scoped>
.logolink {
  .flex-center-v();
}
</style>